import React from 'react';
import {I18n} from 'react-redux-i18n';

import './style.css';

export default function NoData() {
  return <div className="no-data">{I18n.t('noData')}</div>;
}
